import { Donation } from '../shared/model/donation';
import { DonationOption } from '../shared/model/donationoption';
import { ControllerService } from '../shared/service/controller.service';
import {
  Component,
  Input,
  ViewChild,
  AfterViewChecked,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { FrequencyOption } from 'app/shared/model/frequencyoption';
import { DonationFrequency } from '../shared/model/donationfrequency';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-step1-donation',
  templateUrl: './step1-donation.component.html',
  styleUrls: ['./step1-donation.component.css'],
})
export class Step1DonationComponent implements AfterViewChecked {
  donationForm: NgForm;
  @ViewChild('donationForm')
  currentForm: NgForm;
  frequencies: FrequencyOption[];
  model: Donation;
  controller: ControllerService;
  locale: string;
  step = 'step1';
  submitted = false;

  formErrors = {
    'frequency': '',
    'amount_option': '',
    'customAmount': '',
  };

  validationMessages = {
    'name': {
      'required': 'Name is required.',
      'minlength': 'Name must be at least 4 characters long.',
      'maxlength': 'Name cannot be more than 24 characters long.',
      'forbiddenName': 'Someone named "Bob" cannot be a hero.'
    },
  };

  constructor(private router: Router, controller: ControllerService) {
    this.controller = controller;
    this.model = controller.getModel();
    this.locale = controller.locale;
    this.frequencies = controller.configuredFrequencies();
    this.model.payment.frequency = DonationFrequency.ONCE;
    if (environment.BENEFICIARY_GROUP_CODE && environment.BENEFICIARY_GROUP_CODE !== ''){
      this.model.payment.beneficiaryGroupCode = environment.BENEFICIARY_GROUP_CODE;
    }
  }

  ngAfterViewChecked() {
    this.formChanged();
  }

  formChanged() {
    if (this.currentForm === this.donationForm) {
      return;
    }
    this.donationForm = this.currentForm;
    if (this.donationForm) {
      this.donationForm.valueChanges.subscribe((data) =>
        this.onValueChanged(data)
      );
    }
  }

  onValueChanged(data?: any) {
    console.log('onValueChanged');
    if (!this.donationForm) {
      return;
    }
    const form = this.donationForm.form;

    for (const field in this.formErrors) {
      if (this.formErrors.hasOwnProperty(field)) {
        // clear previous error message (if any)
        this.formErrors[field] = 'xxx';
        const control = form.get(field);
        console.log('field: ' + field);
        if (control) {
          console.log('control.dirty: ' + control.dirty);
          console.log('control.valid: ' + control.valid);
        }
        if (control && control.dirty && !control.valid) {
          console.log('yes dirty & !valid');
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            if (this.formErrors.hasOwnProperty(field)) {
              console.log('key: ' + key);
              // this.formErrors[field] += messages[key] + ' ';
            }
          }
        } else {
        }
      }
    }
  }

  isCustomAmountValid() {
    let valid = false;
    if (this.donationForm) {
      const form = this.donationForm.form;
      const control = form.get('customAmount');
      if (control && (!control.dirty || control.valid)) {
        valid = true;
      }
    }
    return valid;
  }

  onSubmit() {
    this.submitted = true;
    console.log('submitted2');
    this.router.navigate(['/step2']);
  }

  /**
   * Getter / Setter donationOption
   */
  get donationOption(): DonationOption {
    return this.controller.donationOption;
  }

  @Input('donationOption')
  set donationOption(option: DonationOption) {
    this.controller.donationOption = option;

    // show hide CustomAmount
    this.controller.showCustomAmount =
      this.controller.donationOption.value == null;
    if (!this.controller.showCustomAmount) {
      // Hide
      this.model.payment.amount = option.value;
    } else {
      // Show
      if (!this.isCustomAmountValid()) {
        this.controller.customAmount = null;
      }

      this.model.payment.amount = this.controller.customAmount;
    }
    this.model.payment.currency = this.controller.getCurrency();
    console.log('amount: ' + this.model.payment);
  }
}
